import React from "react";
import "./Tabs.scss";
import {
  Tooltip,
  getDataAnalyticsProps,
  Label,
  LabelVariant,
} from "@SeemplicityDev/shared";

export interface TabsMenuItem {
  pageLink?: string;
  title?: string;
  badge?: string;
  leftImg?: string;
  rightContent?: React.ReactNode;
  withHelp?: React.ReactNode;
  // Analytics props consumed by getDataAnalyticsProps.
  "data-analytics-event"?: string;
  "data-analytics-props"?: string;
}

export interface TabsProps<T extends TabsMenuItem = TabsMenuItem> {
  menuItems?: T[];
  onSelectTab?: (menuItem: T) => void;
  activeId?: string;
  className?: string;
  isDark?: boolean;
  displayUnderline?: boolean;
  alignLeft?: boolean;
}

const Tabs = <T extends TabsMenuItem = TabsMenuItem>({
  menuItems,
  onSelectTab,
  activeId,
  className,
  isDark = false,
  displayUnderline = true,
  alignLeft = false,
}: TabsProps<T>) => (
  <div
    className={`tabs-menu-wrapper ${isDark ? "is-dark" : ""} ${alignLeft ? "align-left" : ""} ${
      className ? className : ""
    }`}
  >
    <div className={"menu-tabs"}>
      {menuItems?.map((menuItem) => (
        <div
          key={menuItem?.pageLink ?? menuItem?.title}
          className={`tab-item-wrapper${menuItem?.badge ? " has-badge" : ""}${menuItem?.pageLink === activeId ? " active" : ""}`}
          data-testid={`menu-item-${menuItem?.pageLink}`}
          onClick={() => {
            !!onSelectTab && onSelectTab(menuItem);
          }}
          title={menuItem?.title}
          {...getDataAnalyticsProps(menuItem)}
        >
          <div
            className={`sub-header-menu-item-link${
              menuItem?.pageLink === activeId ? " active" : ""
            }`}
          >
            <div
              className={`sub-menu-item-label  ${
                menuItem?.leftImg ? " has-left-img" : ""
              }`}
            >
              {!!menuItem?.leftImg ? (
                <img src={menuItem?.leftImg} alt={menuItem?.title} />
              ) : null}
              <span className={`sub-menu-item-title`}>{menuItem?.title}</span>
              {!!menuItem?.rightContent && menuItem.rightContent}
              {!!menuItem?.withHelp && (
                <Tooltip content={menuItem?.withHelp} type="info">
                  <i className="seem-icon-info info-icon" />
                </Tooltip>
              )}
            </div>
            <div className={`sub-item-underline`} />
          </div>
          {!!menuItem?.badge && (
            <Label
              text={menuItem.badge}
              variant={LabelVariant.Rect}
              className={"tab-badge"}
            />
          )}
        </div>
      ))}
    </div>
    {displayUnderline && <div className={"menu-underline"} />}
  </div>
);

export default Tabs;
